export default __webpack_public_path__ + "static/media/alexandr-podvalny.c68dd8e7.jpg";